export const FETCH_LEAVE_BALANCES = "FETCH_LEAVE_BALANCES";
export const FETCH_LEAVE_BALANCE = "FETCH_LEAVE_BALANCE";
export const EDIT_LEAVE_BALANCE = "EDIT_LEAVE_BALANCE";
